module.exports = __webpack_public_path__ + "img/rules-Icon.350537b9.svg";